/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
define(['endpoints', 'rest/request/requestFactory',
    'apiKeyNames'],
function(endpoints, requestFactory, ApiKeyNames) {
    'use strict';

    var searchApiKeyname = ApiKeyNames.search;

    return function() {
        return {
            geocode: requestFactory.single(endpoints.geocode, searchApiKeyname),
            batch: requestFactory.batch(100, {
                single: endpoints.batchGeocodeQuery,
                batchSync: endpoints.batchSyncSearch,
                batchSearch: endpoints.batchSearch
            }, searchApiKeyname)
        };
    };
});



// WEBPACK FOOTER //
// ./rest/geocode.js